import React, { useLayoutEffect } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { PublicRoute } from './components/PublicRoute';
import { ProtectedRoute } from './components/ProtectedRoute';
import Form from './components/OnboardingForm/Form';
import { Card } from 'native-base';
import ThankYou from './components/ThankYouView/ThankYou';
import Plans from './components/PlansView/Plans';
import Eligibility from './components/EligibilityView/Eligibility';
import { HealthCoachDashboard } from './components/HealthCoachDashboard/HealthCoachDashboard';
import { DashboardDrawer } from './components/HealthCoachDashboard/DashboardDrawer';
import { About } from './components/Settings/About';
import { DietHealth } from './components/Settings/DietHealth';
import { Notifications } from './components/Settings/Notifications';
import { PersonalInfo } from './components/Settings/PersonalInfo';
import { SettingsPage } from './components/Settings/SettingsPage';
import { SubscriptionBilling } from './components/Settings/SubscriptionBilling';
import { useAuth } from './hooks';
import { useModal } from './hooks/useModal';
import { UserDetails } from './components/UserDashboard/UserDetails';
import { DashboardPageStateProvider } from './hooks/useDashboardPageState';
import { UserDashboardRoute } from './routes/UserDashboardRoute';
import { useLogRocket } from './hooks/useLogRocket';
import ContentPreview from './components/ContentPreview/ContentPreview';

export const Root = () => {
  const { user, userData } = useAuth();
  const modalToRender = useModal();

  function Main() {
    const { startLogRocketRecording } = useLogRocket();

    // this method allows us to start the recordings
    // only when in the onboarding to save quota
    useLayoutEffect(() => {
      startLogRocketRecording();
      // eslint-disable-next-line
    }, []);

    return (
      <>
        <div
          className="background-container"
          style={{ overflowX: 'hidden' }}
        ></div>

        <Form />

        {user && (
          <Card>
            <pre>{JSON.stringify(user, null, 2)}</pre>
          </Card>
        )}

        {userData && (
          <Card>
            <pre>{JSON.stringify(userData, null, 2)}</pre>
          </Card>
        )}
      </>
    );
  }

  return (
    <>
      {modalToRender}
      <Router>
        <Routes>
          <Route
            path="/dashboard/*"
            element={
              <ProtectedRoute>
                <DashboardPageStateProvider>
                  <UserDashboardRoute />
                </DashboardPageStateProvider>
              </ProtectedRoute>
            }
          />

          <Route
            path="/hc-dashboard"
            element={
              <ProtectedRoute>
                <HealthCoachDashboard />
              </ProtectedRoute>
            }
          >
            <Route path=":patient" element={<DashboardDrawer />} />
          </Route>

          <Route path="/content-preview" element={<ContentPreview />} />

          <Route
            path="/user-details/:userId/*"
            element={
              <ProtectedRoute>
                <UserDetails />
              </ProtectedRoute>
            }
          />

          <Route path="/onboarding" element={<Form initialPage={1} />} />

          <Route path="/thank-you" element={<ThankYou />} />

          <Route path="/eligibility" element={<Eligibility />} />

          <Route path="/plans" element={<Plans />} />

          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <SettingsPage />
              </ProtectedRoute>
            }
          >
            <Route path="personal-info" element={<PersonalInfo />} />
            <Route path="diet" element={<DietHealth />} />
            <Route path="subscription" element={<SubscriptionBilling />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="about" element={<About />} />
          </Route>

          <Route
            path="/"
            element={
              <PublicRoute>
                <Main />
              </PublicRoute>
            }
          />

          <Route path="*" element={<p>There's nothing here: 404!</p>} />
        </Routes>
      </Router>
    </>
  );
};
